import React from 'react';
import HbFloorsConfig from './HbFloorsConfig';
import HbFloorsJson from './HbFloorsJson';

//mui imports====
import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import useStyles from '../PrebidBiddersConfig/prebidConfigStyle';

const HbFloorsTab = ({ keyData, featureDescription }) => {
	const classes = useStyles();
	const [value, setValue] = React.useState('HBFloorsConfig');
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	console.log('HbFloors Tab is rendering');
	return (
		<Box sx={{ width: '100%', typography: 'body1' }}>
			<TabContext value={value}>
				<Box
					sx={{
						borderBottom: 1,
						borderColor: 'divider',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						marginLeft: '0rem'
					}}
				>
					<TabList
						sx={{
							marginLeft: '0rem'
						}}
						onChange={handleChange}
					>
						<Tab label="HB Floors Config" value="HBFloorsConfig" />
						<Tab label="HB Floors Json" value="HBFloorsJson" />
					</TabList>
				</Box>
				<TabPanel value="HBFloorsConfig">
					<HbFloorsConfig keyData={keyData} featureDescription = {featureDescription}/>
				</TabPanel>
				<TabPanel value="HBFloorsJson">
					<HbFloorsJson keyData={keyData} />
				</TabPanel>
			</TabContext>
		</Box>
	);
};

export default HbFloorsTab;
